/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as MyAPI from '../../../utils/MyAPI'

// GenerateDictionaryModal
const GenerateDictionaryModal = (props) => {

  let [dictionaryNameKey, setDictionaryNameKey] = useState("")
  let [isPublic, setIsPublic] = useState(true)

  let _toggleIsPublic = () => {

    if (isPublic === true) {
      setIsPublic(false)
    } else {
      setIsPublic(true)
    }
  }


  // _generateNewDictionary
  let _generateNewDictionary = async () => {

    props.setLoading(true)

    try {


      if (!dictionaryNameKey) {
        throw Error("名前をつけてください。")
      }

      if (props.copyFromApi === true && !props.copyFromApiKeyId) {
        throw Error("キーが選択されていません。")
      }

      console.log("props.copyFromApi: ", props.copyFromApi)
      // return

      // logout on server
      let _results = await MyAPI.generateNewDictionary({
        login_token: props.login_token,
        dictionary_name: dictionaryNameKey,
        is_public: isPublic,
        copy_from_api_key_id: props.copyFromApiKeyId,
        copy_from_api: props.copyFromApi,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      props.showAlert("追加しました", "success")

      props.closeModal()

    } catch (err) {
      console.log("err: ", err)
      props.showAlert(err.message, "error")
    }
    props.setLoading(false)
  }

  return (
      <Modal isOpen={props.isOpen} toggle={props.closeModal}>
        <ModalHeader toggle={props.closeModal}>
          {props.copyFromApi === true ? (
            <span>
              APIキーと連動した共有可能辞書を作成
            </span>
          ) : (
            <span>
              共有可能辞書を作成
            </span>
          )}
        </ModalHeader>
        <ModalBody>

        <div>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="4" xs="12" style={{
              lineHeight: '36px',
            }}>
              辞書の名前:
            </Col>
            <Col md="8" xs="12">

              <Input
                type="text"
                style={{
                  width: '100%',
                }}
                name='dictionaryNameKeyq'
                onChange={(e) => setDictionaryNameKey(e.target.value)}
                value={dictionaryNameKey}
                placeholder='' />
            </Col>
          </Row>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="4" xs="12" style={{
              lineHeight: '36px',
            }}>
              共有可能範囲:
            </Col>
            <Col md="8" xs="12">

              <FontAwesomeIcon
                onClick={_toggleIsPublic}
                icon={isPublic === true ? "toggle-on" : "toggle-off"}
                style={{
                  marginTop: 12,
                  cursor: 'pointer',
                  marginRight: 6,
              }}/>

              {isPublic === true ? (
                <span>
                  パブリック
                </span>
              ) : (
                <span>
                  プライベート
                </span>
              )}

            </Col>
          </Row>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12" style={{
              textAlign: 'right',
            }}>
              <Button
                onClick={_generateNewDictionary}
                color="success"
                style={{
                  cursor: 'pointer',
                }}>
                辞書を作成する
              </Button>
            </Col>

          </Row>


        </div>

        </ModalBody>
      </Modal>
  );
}

export default GenerateDictionaryModal;
